(function () {
  angular.module('binky.core.user', [
    'binky.core.common.member',
    'binky.core.locale',
    'binky.core.lodash',
    'binky.core.src2-migration',
  ]);
})();
